import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    // Les listes de deals n'ont pas de paramètres de pagination selon la doc API V3
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_PROMOTIONS || '/deals/list', {
      queryParams: {
        restaurantId: payload?.storeId || payload?.restaurantId || undefined,
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch promotions',
        data: null,
      }
    }

    const res = raw.data || {}
    // V3 retourne { data: [...] } pour les listes de deals
    const promos = Array.isArray(res) ? res : (Array.isArray(res.data) ? res.data : [])

    const formatted = promos.map(el => ({
      id: el.id,
      storeId: el.restaurantId || el.storeId,
      storeName: el.restaurantName || el.storeName,
      targetType: el.targetType,
      productsId: el.dishIds || el.productsId || [],
      categoryIds: el.categoryIds || [],
      startDate: el.validFrom || el.startDate,
      endDate: el.validUntil || el.endDate,
      cost: el.discountValue || el.cost || 0,
      type: el.discountType === 'percent' ? 'percentage' : (el.discountType || el.type), // UI uses 'percentage' instead of 'percent'
      value: el.discountValue || el.value,
      status: el.isActive ? 'active' : 'inactive',
      dishNames: el.dishNames || [],
      categoryNames: el.categoryNames || []
    }))

    let data = formatted
    // === Recherche textuelle locale ===
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()
    if (searchTerm) {
      data = data.filter(el => {
        return Object.values(el).some(val => 
          val && typeof val !== 'object' && String(val).toLowerCase().includes(searchTerm)
        )
      })
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      data = [...data].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = data.slice(page * limit, (page + 1) * limit)

    // Le TableList s'attend à un objet avec total et result
    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: searchTerm ? data.length : (res.total || formatted.length),
        result: paginated,
      }
    }
  },
}
